
export function downloadExcelTool() {
  const link = document.createElement("a");
  const excelToolURL: string | undefined = process.env.REACT_APP_EXCEL_TOOL_URL;
  link.href = `${excelToolURL}/`;
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
}
